export const ALL_NOTIFICATIONS_REQUEST = 'ALL_NOTIFICATIONS_REQUEST'
export const ALL_NOTIFICATIONS_SUCCESS = 'ALL_NOTIFICATIONS_SUCCESS'
export const ALL_NOTIFICATIONS_FAIL = 'ALL_NOTIFICATIONS_FAIL'

export const UPDATE_NOTIFICATION_REQUEST = 'UPDATE_NOTIFICATION_REQUEST'
export const UPDATE_NOTIFICATION_SUCCESS = 'UPDATE_NOTIFICATION_SUCCESS'
export const UPDATE_NOTIFICATION_RESET = 'UPDATE_NOTIFICATION_RESET'
export const UPDATE_NOTIFICATION_FAIL = 'UPDATE_NOTIFICATION_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'